// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"226":"f6a16263d9274791","2302":"e9e81166d3afd2fc"}[chunkId] + ".css";
};